var _circle, _path, _path2, _path3, _path4, _path5, _rect, _circle2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyBottle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "m28.045 28.47 6.983-5.38c1.047-.776 3.595-1.763 5.41.5s16.575 21.48 23.728 30.806l-10.137 7.808L28.045 28.47Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#58728C",
  d: "M29.69 27.204 55.734 61.02 41.614 71.896 18.232 41.539c-1.06-1.02-2.433-3.636.545-5.93l10.912-8.405Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.35,
  d: "m21.196 33.746 26.046 33.815-5.629 4.335L18.231 41.54c-1.058-1.021-2.433-3.636.535-5.922l2.43-1.872Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.667,
  d: "M18.695 35.672 35.08 23.05a3.915 3.915 0 0 1 5.49.712l23.68 30.744-22.591 17.4-23.68-30.743a3.916 3.916 0 0 1 .715-5.491Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.667,
  d: "m49.505 79.564 20.148-15.52-6.624-8.6-20.15 15.52 6.626 8.6Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7.31,
  height: 23.707,
  x: 82.741,
  y: 41.82,
  fill: "#F0BDC8",
  stroke: "#36485C",
  strokeWidth: 1.667,
  rx: 3.655,
  transform: "rotate(11.974 82.74 41.82)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.362,
  cy: 73.859,
  r: 3.547,
  fill: "#F0BDC8",
  stroke: "#36485C",
  strokeWidth: 1.667,
  transform: "rotate(11.974 79.362 73.86)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 11.667,
  x: 49.667,
  y: 89.333,
  stroke: "#36485C",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  rx: 0.833
})));
export default SvgEmptyBottle;